import { NavLink, Routes, Route, Navigate } from "react-router-dom";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { ClaimsFindingTab } from "./ui/ClaimsFindingTab";
import { ChatResponseTab } from "./ui/ChatResponseTab";
import { IntelligenceQuestionsTab } from "./ui/IntelligenceQuestionsTab";

export function AiEvalsPage() {
  const tabs = [
    { path: "claims-extraction", label: "Claims Extraction" },
    { path: "chat-response", label: "Chat Response" },
    { path: "intelligence-questions", label: "Intelligence Questions" }
  ];

  return (
    <div className="container mx-auto py-8 pt-[95px] min-h-[calc(100vh-51px-64px)]">
      <div className="flex justify-between items-center mb-6">
        <FigmaTypography component="h1" variant="heading-1">AI Evals</FigmaTypography>
      </div>

      <div className="bg-white rounded-lg shadow-sm">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6" aria-label="Tabs">
            {tabs.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={({ isActive }) =>
                  `py-4 px-1 border-b-2 font-medium text-[14px] transition-colors ${
                    isActive
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="p-6">
          <Routes>
            <Route index element={<Navigate to="claims-extraction" replace />} />
            <Route path="claims-extraction" element={<ClaimsFindingTab />} />
            <Route path="chat-response" element={<ChatResponseTab />} />
            <Route path="intelligence-questions" element={<IntelligenceQuestionsTab />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
